<template>
    <div class="app-container">
        <div class="filter-head">
            <div>
                <el-button type="primary" @click="handleAddTable">新增</el-button>
                <el-button type="warning" :loading="listLoading" icon="el-icon-upload2"
                    @click="exportExcel">导出Excel</el-button>
            </div>
            <div class="status-filter">
                <el-input v-model="listQuery.name" placeholder="商家名称" clearable></el-input>
                <div class="select">
                    <el-select v-model="listQuery.state" placeholder="状态" clearable>
                        <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <el-button type="primary" :loading="listLoading" icon="el-icon-search" @click="handleFilter">搜索</el-button>
            </div>
        </div>
        <div class="table">
            <el-table v-loading="listLoading" element-loading-text="Loading" :data="tableData" border fit
                highlight-current-row>
                <el-table-column type="index" label="序号" width="95" align="center" />
                <el-table-column prop="name" label="商家名称" min-width="110" align="center" />
                <el-table-column prop="details" label="商家介绍" min-width="110" align="center" />
                <el-table-column prop="contact_name" label="联系人" min-width="110" align="center" />
                <el-table-column prop="contact_phone" label="联系电话" min-width="110" align="center">
                    <template slot-scope="scope">
                        <p style="cursor: pointer;" @click="textCopyAction(scope.row.contact_phone)">{{
                            scope.row.contact_phone
                        }}
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="account" label="账号" min-width="110" align="center">
                    <template slot-scope="scope">
                        <p style="cursor: pointer;white-space: nowrap; overflow: hidden; text-overflow:ellipsis"
                            @click="textCopyAction(scope.row.account)">{{ scope.row.account }}
                        </p>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="password" label="密码" min-width="110" align="center">
                    <template slot-scope="scope">
                        <p style="cursor: pointer;white-space: nowrap; overflow: hidden; text-overflow:ellipsis"
                            @click="textCopyAction(scope.row.password)">
                            {{ scope.row.password }}
                        </p>
                    </template>
                </el-table-column> -->
                <el-table-column prop="state" label="状态" min-width="110" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state === 1" type="success">正常</el-tag>
                        <el-tag v-else-if="scope.row.state === 0" type="warning">冻结</el-tag>
                        <el-tag v-else>后端无字段</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEditTable(scope.row)">编辑</el-button>

                        <el-button v-if="scope.row.state === 1" type="warning" size="mini" :loading="changingState"
                            @click="handleForbid(scope.row.id, '冻结')">冻结</el-button>

                        <el-button v-else size="mini" type="primary" :loading="changingState"
                            @click="handleForbid(scope.row.id, '解冻')">解冻
                        </el-button>

                        <el-popconfirm title="确定初始密码?" @confirm="initPassword(scope.row.id)"   @onConfirm="initPassword(scope.row.id)">
                            <el-button type="danger" slot="reference" size="mini" style="margin-left:10px;">初始密码
                            </el-button>
                        </el-popconfirm>

                        <!-- <el-popconfirm title="确定删除?" @confirm="handleDeleteTable(scope.row.id)"   @onConfirm="handleDeleteTable(scope.row.id)">
                            <el-button type="danger" slot="reference" size="mini" style="margin-left:10px;">删除
                            </el-button>
                        </el-popconfirm> -->
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <TableActionModal :show.sync="visible" :type="modalType" :edit-data="editData"
            @onUpdate="onTableActionModalSubmit" />
    </div>
</template>

<script>
// 商家管理
import { merchant } from "@/api/userManagement"
import TableActionModal from './components/TableActionModal.vue';
import * as XLSX from "xlsx"
import { map } from "async";

export default {
    data: () => ({
        selectOptions: [
            {
                value: 1,
                label: '正常'
            }, {
                value: 0,
                label: '冻结'
            }
        ],
        listLoading: true,
        tableData: [],
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            name: "",
            state: null,
        },
        modalType: 'add',
        visible: false,
        editData: null,
        changingState: false
    }),
    components: {
        TableActionModal
    },
    methods: {
        getList() {
            this.listLoading = true

            merchant.list(this.listQuery).then(({ data }) => {
                this.tableData = data.data
                this.total = data.total
                this.listLoading = false
            })
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList()
        },
        // 表格操作
        handleEditTable(e) {
            this.setModalType('edit')
            this.visible = true
            this.editData = e
        },
        handleForbid(id, content) {
            this.$confirm("此操作将" + content + "该商家, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.changingState = true
                merchant.changeStatus(id).then((res) => {
                    this.getList()
                    this.$message({
                        message: '操作成功!',
                        type: 'success'
                    });
                }).catch(() => { this.$message.error('操作失败!'); }).finally(() => {
                    this.changingState = false
                })
            })
        },
        onTableActionModalSubmit() {
            this.getList()
        },
        // async handleDeleteTable(id) {
        //     try {
        //         await merchant.delEvent(id)
        //         this.getList()
        //         this.$message({
        //             message: '操作成功!',
        //             type: 'success'
        //         });
        //     } catch {
        //         this.$message.error('操作失败!');
        //     }
        // },
        async initPassword(id) {
            try {
                await merchant.initPassword(id)
                this.getList()
                this.$notify({
                    title: '成功',
                    message: '密码初始为: 123456',
                    type: 'success'
                });
            } catch {
                this.$message.error('操作失败!');
            }
        },
        // 复制
        textCopyAction(content) {
            if (content) {
                var aux = document.createElement("input");
                aux.setAttribute("value", content);
                document.body.appendChild(aux);
                aux.select();
                document.execCommand("copy");
                this.$message({
                    message: '已复制到剪贴板',
                    type: 'success'
                });
                document.body.removeChild(aux);
            }
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        // 更改模式
        setModalType(type) {
            this.modalType = type
        },
        // 添加数据
        handleAddTable() {
            this.setModalType('add')
            this.visible = true
        },
        // 导出Excel
        async exportExcel() {
            console.log('exportExcel')

            const { total } = this
            if (!total) return

            try {
                const { data: { data: reqData } } = await merchant.list({ ...this.listQuery, page: 1, limit: total })

                var wb = XLSX.utils.book_new();

                var excelData = [
                    ['序号', '商家名称', '商家介绍', '联系人', '联系电话', '账号', '状态'],
                    ...reqData.map((item, index) => [index + 1, item.name, item.details, item.contact_name, item.contact_phone, item.account, item.state ? '正常' : '冻结'])
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "商家列表");
                XLSX.writeFile(wb, "商家列表.xlsx");

                this.$notify.info({
                    title: '消息',
                    message: '请等待, 正在生成Excel表格文件...'
                });
            } catch {
                this.$notify.error({
                    title: '错误',
                    message: '获取数据错误!'
                });
            }
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style scoped lang="scss">
.filter-head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .status-filter {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .select {
            margin: 0 8px;
        }
    }
}

.table {
    margin-top: 10px;
}
</style>